var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorRetry = function SvgErrorRetry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328,
    height: 80,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#errorRetry_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m183.692 56.342-3.314 3.314-13.534-13.535a6.7 6.7 0 0 1-2.807.615c-2.89 0-5.36-1.83-6.314-4.392h-9.496v-4.687h9.496a6.75 6.75 0 0 1 6.314-4.391A6.743 6.743 0 0 1 170.773 40a6.7 6.7 0 0 1-.615 2.806z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M164.033 37.953a2.05 2.05 0 0 0-2.049 2.048c0 1.13.919 2.049 2.049 2.049A2.05 2.05 0 0 0 166.081 40a2.05 2.05 0 0 0-2.048-2.048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#errorRetry_svg__b)",
    d: "M198.431 37.658a34.3 34.3 0 0 0-3.116-12.193l-17.139-2.921 5.227-5.227a29.56 29.56 0 0 0-17.027-7.051v4.614h-4.687v-4.614c-14.582 1.138-26.254 12.81-27.392 27.392h4.615v4.687h-4.615c1.139 14.583 12.81 26.254 27.392 27.393v-4.615h4.687v4.614c14.583-1.138 26.254-12.81 27.392-27.392h-4.614v-4.687zm-14.743 18.684-3.314 3.314-13.535-13.534a6.7 6.7 0 0 1-2.806.615c-2.89 0-5.36-1.83-6.314-4.392h-9.497v-4.687h9.497a6.75 6.75 0 0 1 6.314-4.392 6.743 6.743 0 0 1 6.735 6.736 6.7 6.7 0 0 1-.615 2.806z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#errorRetry_svg__c)",
    d: "M203.964 42.343h-5.496c-.555 8.337-4.068 16.099-10.031 22.062-6.519 6.52-15.187 10.11-24.406 10.11s-17.886-3.59-24.405-10.11S129.517 49.22 129.517 40s3.59-17.886 10.109-24.405 15.186-10.11 24.405-10.11 17.887 3.59 24.406 10.11l1.656 1.656-2.193 2.194 9.413 1.605-1.605-9.413-1.737 1.737-1.657-1.657C184.759 4.16 174.714 0 164.031 0s-20.729 4.16-28.284 11.716-11.716 17.6-11.716 28.284 4.161 20.73 11.716 28.284C143.302 75.84 153.347 80 164.031 80c10.685 0 20.73-4.16 28.285-11.716 6.999-7 11.085-16.138 11.648-25.94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#errorRetry_svg__d)",
    d: "m203.658 72.27-11.66-19.817c-.962-1.635-2.646-2.453-4.329-2.453l-6.271 14.815 6.271 14.815h11.659c3.849 0 6.254-4.09 4.33-7.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#errorRetry_svg__e)",
    d: "m183.337 52.453-11.66 19.817c-1.924 3.27.481 7.36 4.33 7.36h11.66V50c-1.684 0-3.368.818-4.33 2.453"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3.704,
    d: "M187.664 57.406v10.185M187.664 73.14v1.853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "errorRetry_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-67.13312 53.86077 -48.8957 -60.94457 207.753 14.137)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACBEDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "errorRetry_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(132.971 97.809 45.655)scale(99.0194 91.8499)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AAAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "errorRetry_svg__d",
    x1: 192.867,
    x2: 192.867,
    y1: 47.712,
    y2: 90.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "errorRetry_svg__e",
    x1: 179.333,
    x2: 179.333,
    y1: 47.712,
    y2: 90.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "errorRetry_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M124 0h80v80h-80z"
  })))));
};
export default SvgErrorRetry;